import React, { useState } from "react";

import { Popover } from "@mui/material";

import { FormGroup } from "@cofano/cck";

import { intl } from "LocaleWrapper";
import SailingScheduleSelect, { SailingScheduleSelectOption } from "view/sailingschedules/components/selects/SailingScheduleSelect";

import "../../declarations.scss";

const ScheduleFilter = ({ onSelectSchedule }: {
	onSelectSchedule: (schedule: SailingScheduleSelectOption | null) => void;
}) => {

	const [schedule, setSchedule] = useState<SailingScheduleSelectOption | null>(null);
	const [anchorEl, setAnchorEl] = useState<HTMLSpanElement | null>(null);

	const open = Boolean(anchorEl);
	const id = open ? "schedule-filter-popover" : undefined;

	return (
		<React.Fragment>
			<span className="schedule-filter">
				<span
					onClick={(event: React.MouseEvent<HTMLSpanElement>) =>
						setAnchorEl(event.currentTarget)
					}
				>
					{`${intl.formatMessage({ id: "VOYAGE_SCHEDULE" })}: ${schedule?.schedule ?? intl.formatMessage({ id: "NOT_SET" })}`}
				</span>

				<Popover
					id={id}
					open={open}
					anchorEl={anchorEl}
					onClose={() => setAnchorEl(null)}
					anchorOrigin={{
						vertical: "bottom",
						horizontal: "center",
					}}
					transformOrigin={{
						vertical: "top",
						horizontal: "center",
					}}>

					<div style={{ width: 300, padding: 16 }}>
						<FormGroup label={intl.formatMessage({ id: "VOYAGE_SCHEDULE" })}>
							<SailingScheduleSelect
								clearable
								value={schedule}
								onChange={(option) => {
									setSchedule(option);
									onSelectSchedule(option);
								}}
							/>
						</FormGroup>
					</div>
				</Popover>
			</span>
		</React.Fragment>
	);
};

export default ScheduleFilter;
